var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 38,
    viewBox: "0 0 67 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2863 0L59.9902 0.136691L23.841 38H-5.00983L31.2863 0Z",
    fill: "url(#paint0_linear_115_13)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8591 8.82997H28.3891V5.91497C28.3891 4.30601 27.083 3 25.4741 3H2.91497C1.30601 3 0 4.30601 0 5.91497V33.5299C0 35.9938 2.00616 38 4.4701 38H30.5299C32.9938 38 35 35.9938 35 33.5299V10.9707C35 9.79264 34.0373 8.82997 32.8591 8.82997ZM33.0544 33.5299C33.0544 34.9234 31.9234 36.0612 30.5231 36.0612H4.46332C3.06978 36.0612 1.93212 34.9302 1.93212 33.5299V5.91497C1.93212 5.37641 2.36968 4.94558 2.90151 4.94558H25.4606C25.9992 4.94558 26.43 5.38314 26.43 5.91497V29.2551C26.43 29.7936 26.8677 30.2245 27.3995 30.2245C27.9314 30.2245 28.3689 29.7869 28.3689 29.2551V10.7755H32.839C32.9467 10.7755 33.0342 10.863 33.0342 10.9707V33.5299H33.0544Z",
    fill: "#003851"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3265 14.081H17.941C17.5097 14.081 17.16 14.4306 17.16 14.8619V15.2456C17.16 15.6769 17.5097 16.0266 17.941 16.0266H23.3265C23.7578 16.0266 24.1074 15.6769 24.1074 15.2456V14.8619C24.1074 14.4306 23.7578 14.081 23.3265 14.081Z",
    fill: "#003851"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82266 21.4459H10.8858C12.8313 21.4459 14.4134 19.8638 14.4134 17.9183V12.1893C14.4134 10.2437 12.8313 8.66168 10.8858 8.66168H7.82266C5.87709 8.66168 4.29504 10.2437 4.29504 12.1893V17.9183C4.29504 19.8638 5.87709 21.4459 7.82266 21.4459ZM6.2137 12.1825C6.2137 11.2939 6.93402 10.5736 7.82266 10.5736H10.8858C11.7744 10.5736 12.4947 11.2939 12.4947 12.1825V17.9115C12.4947 18.8002 11.7744 19.5205 10.8858 19.5205H7.82266C6.93402 19.5205 6.2137 18.8002 6.2137 17.9115V12.1825Z",
    fill: "#003851"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3265 8.6347H17.941C17.5097 8.6347 17.16 8.98434 17.16 9.41563V9.79935C17.16 10.2306 17.5097 10.5803 17.941 10.5803H23.3265C23.7578 10.5803 24.1074 10.2306 24.1074 9.79935V9.41563C24.1074 8.98434 23.7578 8.6347 23.3265 8.6347Z",
    fill: "#003851"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3265 19.5272H17.941C17.5097 19.5272 17.16 19.8769 17.16 20.3081V20.6919C17.16 21.1232 17.5097 21.4728 17.941 21.4728H23.3265C23.7578 21.4728 24.1074 21.1232 24.1074 20.6919V20.3081C24.1074 19.8769 23.7578 19.5272 23.3265 19.5272Z",
    fill: "#003851"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.34 24.9667H5.04906C4.62149 24.9667 4.27484 25.3133 4.27484 25.7409V26.1381C4.27484 26.5657 4.62149 26.9123 5.04906 26.9123H23.34C23.7676 26.9123 24.1143 26.5657 24.1143 26.1381V25.7409C24.1143 25.3133 23.7676 24.9667 23.34 24.9667Z",
    fill: "#003851"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1674 30.413H5.04906C4.62149 30.413 4.27484 30.7596 4.27484 31.1872V31.5843C4.27484 32.0119 4.62149 32.3585 5.04906 32.3585H15.1674C15.595 32.3585 15.9415 32.0119 15.9415 31.5843V31.1872C15.9415 30.7596 15.595 30.413 15.1674 30.413Z",
    fill: "#003851"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_115_13",
    x1: -5.00983,
    y1: 19,
    x2: 59.9902,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.141667,
    stopColor: "#C0CE54",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426667,
    stopColor: "#C0CE54",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631667,
    stopColor: "#6EBA72",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811667,
    stopColor: "#00A19B",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003C56",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 38,
    fill: "white",
    transform: "translate(2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecond);
export default __webpack_public_path__ + "static/media/second.6df13e6fb5aaed513e865562f16df065.svg";
export { ForwardRef as ReactComponent };